var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1786 35.2561C37.0028 35.2693 36.0946 35.3235 34.0686 35.3235C32.4572 35.3235 31.3131 35.2752 30.9117 35.2561C24.6844 34.9822 20.0362 33.8981 20.0362 32.6002C20.0362 31.3023 24.6844 30.2197 30.9117 29.9414V34.1765C31.319 34.2058 32.485 34.2746 34.0964 34.2746C36.0301 34.2746 36.9984 34.1941 37.1728 34.1779V29.9443C43.3869 30.2212 48.0248 31.3052 48.0248 32.6002C48.0248 33.8952 43.3884 34.9792 37.1728 35.2546L37.1786 35.2561ZM37.1786 29.5063V25.7166H45.8509V19.9375H22.2394V25.7166H30.9103V29.5049C23.8626 29.8286 18.5625 31.2247 18.5625 32.8976C18.5625 34.5705 23.8626 35.9651 30.9103 36.2903V48.4345H37.1772V36.2859C44.2087 35.9622 49.5 34.5676 49.5 32.8961C49.5 31.2247 44.2131 29.8301 37.1772 29.5049L37.1786 29.5063Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.b0037e74ec8c38434cbd1325c306454f.svg";
export { ForwardRef as ReactComponent };